let $ = require('jquery');
let Vue = require('vue');

Vue.directive('file', {
    twoWay: true,
    priority: 1000,
    params: [],
    bind: function () {
        $(this.el).on('reset.bs.fileinput clear.bs.fileinput change.bs.fileinput', this.handleChange.bind(this));
    },
    update: function (value) {

    },
    unbind: function () {
        $(this.el).unbind('reset.bs.fileinput clear.bs.fileinput change.bs.fileinput');
    },
    handleChange(e) {
        this.set(e.target.files[0]);
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/file.js